import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';
import { getProjectNameHeader } from '@/utils/imUtils';

const baseUrl = envConfig.formalServer + '/plat/admin/im/status/';

function baseApi() {

    function query(data, projectName) {
        return Post(baseUrl + 'queryImUserStatus', data, getProjectNameHeader(projectName));
    }

    return {
        query
    };
}

export const imUserStatusApi = baseApi();
